import { getHeaders } from './localStorage';
import axios from 'axios';
import { api, versao } from '../config';
import errorHandling from './errorHandling';

export const getUsuariosAdmin = () => {
	return function () {
		return axios.get(`${api}/${versao}/api/usuarios/admin`, getHeaders())
			.then((response) => response.data)
			.catch(errorHandling);
	};
};

export const postUsuarioAdmin = (body) => {
	return function () {
		return axios.post(`${api}/${versao}/api/usuarios/admin`, body, getHeaders())
			.then((response) => response.data)
			.catch(errorHandling);
	};
};

export const putUsuarioAdmin = (id, body) => {
	return function () {
		return axios.put(`${api}/${versao}/api/usuarios/admin/${id}`, body, getHeaders())
			.then((response) => response.data)
			.catch(errorHandling);
	};
};

export const deleteUsuarioAdmin = (id) => {
	return function () {
		return axios.delete(`${api}/${versao}/api/usuarios/admin/${id}`, getHeaders())
			.then((response) => response.data)
			.catch(errorHandling);
	};
};
